import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api';

export default function CorreosPage() {
  const { cid } = useParams();
  const [historial, setHistorial] = useState([]);
  const [plantilla, setPlantilla] = useState(null);
  const [variables, setVariables] = useState([]);
  const [form, setForm] = useState({ asunto: '', html: '' });
  const [error, setError] = useState('');
  const [msg, setMsg] = useState('');

  const load = () => {
    api.get(`/gastos-comunes/condominios/${cid}/emails/historial`).then((r) => setHistorial(r.data));
    api.get(`/gastos-comunes/condominios/${cid}/emails/plantillas`).then((r) => {
      const p = r.data.find((x) => x.tipo === 'comprobante_pago') || r.data[0];
      if (p) {
        setPlantilla(p);
        setForm({ asunto: p.asunto, html: p.html });
      }
    });
    api.get(`/gastos-comunes/condominios/${cid}/emails/variables`).then((r) => setVariables(r.data));
  };

  useEffect(() => {
    if (cid) {
      localStorage.setItem('gc_condominio_id', cid);
      load();
    }
  }, [cid]);

  const guardarPlantilla = async (e) => {
    e.preventDefault();
    if (!plantilla?.id) return;
    setError('');
    setMsg('');
    try {
      await api.patch(`/gastos-comunes/condominios/${cid}/emails/plantillas/${plantilla.id}`, form);
      setMsg('Plantilla actualizada.');
      load();
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
  };

  const reintentar = async (id) => {
    setError('');
    try {
      await api.post(`/gastos-comunes/condominios/${cid}/emails/${id}/reintentar`);
      setMsg('Reintento procesado.');
      load();
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
  };

  return (
    <>
      <div className="page-header">
        <h2>Correos y recibos</h2>
        <p>Al registrar un pago se genera PDF y se encola el comprobante (SMTP compartido con informes IVA). Modo PRUEBA redirige al correo de prueba.</p>
      </div>
      {error && <div className="alert alert-error">{error}</div>}
      {msg && <div className="alert alert-success">{msg}</div>}

      <div className="card">
        <h3 className="card-title">Plantilla — comprobante de pago</h3>
        <p style={{ color: 'var(--gc-muted)', fontSize: '0.875rem' }}>
          Variables: {variables.map((v) => `{{${v}}}`).join(', ')}
        </p>
        <form onSubmit={guardarPlantilla}>
          <div className="field">
            <label>Asunto</label>
            <input value={form.asunto} onChange={(e) => setForm({ ...form, asunto: e.target.value })} required />
          </div>
          <div className="field">
            <label>Cuerpo HTML</label>
            <textarea rows={8} value={form.html} onChange={(e) => setForm({ ...form, html: e.target.value })} required />
          </div>
          <button type="submit" className="btn">
            Guardar plantilla
          </button>
        </form>
      </div>

      <div className="card">
        <h3 className="card-title">Historial de envíos</h3>
        <div className="table-wrap">
          <table className="data-table">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Tipo</th>
                <th>Destinatario</th>
                <th>Estado</th>
                <th>Intentos</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {historial.map((row) => (
                <tr key={row.id}>
                  <td>{row.createdAt ? new Date(row.createdAt).toLocaleString('es-CL') : '—'}</td>
                  <td>{row.tipo}</td>
                  <td>{row.destinatario}</td>
                  <td>
                    {row.estado}
                    {row.ultimoError && (
                      <div style={{ fontSize: '0.75rem', color: 'var(--gc-danger)' }}>{row.ultimoError}</div>
                    )}
                  </td>
                  <td>{row.intentos}</td>
                  <td>
                    {row.estado === 'fallido' && (
                      <button type="button" className="btn secondary" onClick={() => reintentar(row.id)}>
                        Reintentar
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {!historial.length && <p style={{ color: 'var(--gc-muted)' }}>Sin envíos aún.</p>}
      </div>
    </>
  );
}
